import { render, staticRenderFns } from "./TeamOfRivalsArticle.vue?vue&type=template&id=691587d0&"
import script from "./TeamOfRivalsArticle.vue?vue&type=script&lang=js&"
export * from "./TeamOfRivalsArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports